'use strict';


var nodeMap = require('../node.map.js');/*,

    group = {
        name: '',
        list: [],
        active: null
    };*/


/* eslint no-useless-call: 0 */


module.exports = function ( value, callback ) {
    var self = this,
        $layout = document.createElement('div'),
        $icon = document.createElement('div'),
        $text = document.createElement('div');


    while ( nodeMap.data[this.id].firstChild ) {
        nodeMap.data[this.id].removeChild(nodeMap.data[this.id].firstChild);
    }

    $text.innerText = this.name;

    $icon.className = 'theme-icon ' + this.icon;
    $text.className = 'settings-list-item-name';

    $layout.className = 'mag-component-layout';

    $layout.appendChild($icon);
    $layout.appendChild($text);

    if ( this.config && this.config.group ) {
        // if ( group.name !== this.config.group ) {
        //     group.name = this.config.group;
        //     group.list.splice(0);
        //     group.active = null;
        // }

        $icon = document.createElement('div');
        $layout.appendChild($icon);

        // group.list.push({
        //     option: this,
        //     $icon: $icon
        // });

        if ( this.config.enabled  ) {
            // group.active = group.list[group.list.length - 1];
            $icon.className = 'theme-icon theme-icon theme-icon-ok';
        }
    }

    // $node here
    nodeMap.data[this.id].appendChild($layout);

    if ( this instanceof require('../models/option') ) {
        this.events.change = [
            function ( isChanged ) {
                nodeMap.data[self.id].listInstance.$nodeChange(isChanged, self);
            }
        ];

        nodeMap.data[this.id].onclick = function () {
            if ( self.events.click ) {
                self.emit('click');
            } else {
                self.saver.call(self);
            }
        };
    }

    callback();
};
